<!-- 「更新が完了しました」等のメッセージを出力する -->
<template>
    <div id="overlay" v-if="message_flag0">
        <div id="content_modal">
            <div style="padding:20px 0" v-html="message_text">
            </div>

            <!-- message_cat=3（OKのみ）の場合はこちらを表示 -->
            <div class="row justify-content-center" v-if="move_shakyo" style="display:block;width: 100%;margin: auto;">
                
                    <button  class="btn btn-primary btn_confirm" style="width: 48%;float: left;" v-on:click="OK_message()">所属社協に移動</button>
                    
                    <button  class="btn btn-secondary btn_confirm" style="width: 48%;float:right" v-on:click="log_out()">ログアウト</button>
            </div>

            <!-- message_cat=0 or 2（OKのみ）の場合はこちらを表示 -->
            <div class="row justify-content-center" v-if="alert_button">
                <button  class="btn btn-primary btn_confirm"  v-on:click="OK_message()">OK</button>
                
                <!-- message_cat=2の場合はこちらを表示 -->
                <p v-if="logout_link" v-on:click="log_out()" style="cursor:pointer;padding-top:10px"><u>ログアウト</u></p>
            </div>

            <!-- message_cat=1（OK or キャンセルの選択式）の場合はこちらを表示 -->
            <div v-if="confirm_button">
                <div class="row justify-content-center pc_button" >
                    <div class="col-md-auto">
                        <button  class="btn btn-primary btn_confirm" v-on:click="OK_message()">OK</button>
                    </div>
                    <div class="col-md-auto">
                        <button  class="btn btn-secondary btn_confirm" v-on:click="Close_message()">キャンセル</button>
                    </div>
                </div>

                <div class="sp_button">
                    <button  class="btn btn-secondary btn_confirm" style="width: 45%;" v-on:click="Close_message()">キャンセル</button>

                    <button  class="btn btn-primary btn_confirm" style="width: 45%;" v-on:click="OK_message()">OK</button>
                  
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
/* eslint-disable */
import { ref, watch } from 'vue'

// このvueファイルのみで行われる処理を記述
let alert_button = false    //message_cat=0（OKのみ）の場合はこちらをtrueにする
let confirm_button = false  //message_cat=1（OK or キャンセルの選択式）の場合はこちらをtrueにする 
let logout_link = false  //message_cat=2（OKのみ）かつログアウトのリンクを表示したい場合はこちらをtrueにする         
let move_shakyo = false  //message_cat=3かつログアウトのリンクを表示したい場合はこちらをtrueにする

// message（表示するメッセージ）
// message_cat（0：OKのみ、1：OK or キャンセルの選択式）
// message_flag（表示・非表示フラグ）

const props = defineProps([
    "message_text",
    "message_cat",
    "message_flag"
    ]);

let message_flag0 = ref(props.message_flag);

watch(props.message_flag, () => {
    // ウィンドウが表示されたときに検索を開始
    if(props.message_flag == true){
        Check();
    }
})

let Check = function(){  //表示時の確認
    alert_button = false;
    confirm_button = false;
    logout_link = false
    // message_cat（0：OKのみ、1：OK or キャンセルの選択式）
    if(props.message_cat == 0){
        alert_button = true;
    } else if (props.message_cat == 1){
        confirm_button = true;
    }else if(props.message_cat == 2){
        alert_button = true;
        logout_link = true
    }else if(props.message_cat == 3){
        move_shakyo = true;
    }
}

const emit = defineEmits(['ok_message','close_message','call']);

let OK_message = function(){  //このウィンドウを閉じて親コンポーネント側で処理を行う
    message_flag0 = false;
    emit('ok_message',message_flag0);
}

let Close_message = function(){  //このウィンドウを閉じる
    message_flag0 = false;
    emit('close_message',message_flag0);
}

const log_out = function() {
    message_flag0 = false;
    emit('call', { cmd:'logout'})
}
/* 初期処理 */
Check();
</script>

<style scoped>
#overlay{
  /* 要素を重ねた時の順番 */
  z-index:1001;

  /* 画面全体を覆う設定 */
  position:fixed;
  top:0;
  left:0;
  width:100%;
  height:100%;
  background-color:rgba(0,0,0,0.5);

  /* 画面の中央に要素を表示させる設定 */
  display: flex;
  align-items: center;
  justify-content: center;
}

#content_modal{
  /* 要素を重ねた時の順番 */
  z-index:1002;
  height:auto;
  text-align: center;
  padding: 1em;
  background:#fff;
  white-space: pre-line;
}
#content_modal button{
    width:150px;
    height:40px;
    padding: 0;
}


@media screen and (min-width: 961px) {

    /* PC版 */ 
    #content_modal{
        max-width: 90%;
        min-width:330px;
    } 
    .pc_button{
        display:flex
    }
    .sp_button{
        display:none
    }
    
}
@media screen and (max-width: 960px) {
        
    #content_modal{
        width: 90%;
        max-width:340px;
    }
    .pc_button{
        display:none
    }
    .sp_button{
        display:flex;justify-content: space-around;
    }
}
</style>